import { DEPARTMENT_ID } from "./constants/department";

export default function access(initialState: { currentUser?: any } | undefined) {
  const { currentUser } = initialState ?? {};
  // Quản lý tài liệu
  const canMaterial = currentUser && (currentUser.userType === 3 || currentUser.userType === 4 || currentUser.userType === 5);
  const canFolder = currentUser && currentUser.userType !== 0;
  const canStudent = currentUser && currentUser.userType === 0;
  const dean = currentUser && (currentUser.userType === 3 || currentUser.userType === 4 || currentUser.userType === 5);
  const leader = currentUser && (currentUser.userType === 2 || currentUser.userType === 3 || currentUser.userType === 4 || currentUser.userType === 5);
  const student = currentUser && currentUser.userType === 0;
  const canExport = currentUser && currentUser.departmentId === DEPARTMENT_ID.TMO;
  return {
    canAdmin: currentUser && (currentUser.roles?.includes('Admin') || currentUser.userType === 5),
    canMaterial,
    canFolder,
    canStudent,
    dean,
    leader,
    student,
    canExport
  };
}
